import { Howl } from "howler";
import { getUserById } from "../../Services/Pointeuse/UsersApi";
import { getSession, isLogin } from "../../Utils/SessionUtils";
import ImageComponent from "../Styles/ImageComponent";
import socket from "../../Connection/ws";
import toast from "react-hot-toast";

/* Used to play a sound when a notification is displayed. */
var notifSound = new Howl({
  src: ["./assets/sounds/notif.mp3"],
  loop: false,
  preload: true,
});

/**
 * The function is used to display a notification when a user is autorised to use a tool
 */
export function AutorisationNotification() {
  socket.on("autorisation", (result) => {
    if (isLogin() && result.code_generated == getSession("code_generated")) {
      notifSound.play();
      getUserById(result.user_code_id).then((res) => {
        res.data.id &&
          toast.custom(
            (t) => (
              <div className="" style={{ width: 500, borderRadius: "60px", backgroundColor: "#333" }}>
                <div className="p-3">
                  <div className="d-flex align-items-center mt-auto" style={{ float: "left" }}>
                    <ImageComponent atr={"avatar avatar-md brround mr-3"} picture={res.data.img}></ImageComponent>
                    <div>
                      <a href="#" className="font-weight-semibold">
                        {res.data.nom} {res.data.prenom}
                      </a>
                      <small className="d-block text-muted fa-12">
                        Demande autorisation {result.objet} de {result.nb_heure} H à partir de {result.date}{" "}
                        {result.heure_debut}
                      </small>
                    </div>
                  </div>
                  <div className="border-l border-gray-200 mb-4" style={{ float: "right" }}>
                    <a href="#" onClick={() => toast.dismiss(t.id)} class="btn btn-pill btn-light">
                      voir
                    </a>
                  </div>
                </div>
              </div>
            ),
            { duration: 5000 }
          );
      });
    }
  });
}
